import React from "react";
import {sectionService} from "../../jwt/_services/landings/sectionService";

export const sectionProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await sectionService.getOptions( customFilter );

        console.log({listItems})

        return listItems.map( ({id, code, name}) => ({
                id,
                value: `${code}${name ? ` - ${name}` : ''}`,
                label: <label>{ `${code}${name ? ` - ${name}` : ''}` }</label>
            })
        );
    } catch (error) {
        console.log(error.message)
    }
}